<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Cached Domains</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-database me-1" style="color: #00A0C1;"></i>
                  Manage cached domain safety classifications and expiry.
               </small>
            </div>
         </div>
      </div>

      <CachedDomains />
   </div>
</template>

<script>
import CachedDomains from '@/components/Admin Controls/CachedDomains.vue';

export default {
   components: { CachedDomains },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>